export var ImageFileType;
(function (ImageFileType) {
    ImageFileType["svg"] = "image/svg+xml";
    ImageFileType["jpeg"] = "image/jpeg";
    ImageFileType["jpg"] = "image/jpg";
    ImageFileType["png"] = "image/png";
    ImageFileType["webp"] = "image/webp";
})(ImageFileType || (ImageFileType = {}));
export const validMimeType = Object.values(ImageFileType);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW1hZ2VGaWxlVHlwZS5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJpbWFnZUZpbGVUeXBlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLGFBTVg7QUFORCxXQUFZLGFBQWE7SUFDdkIsc0NBQXFCLENBQUE7SUFDckIsb0NBQW1CLENBQUE7SUFDbkIsa0NBQWlCLENBQUE7SUFDakIsa0NBQWlCLENBQUE7SUFDakIsb0NBQW1CLENBQUE7QUFDckIsQ0FBQyxFQU5XLGFBQWEsS0FBYixhQUFhLFFBTXhCO0FBRUQsTUFBTSxDQUFDLE1BQU0sYUFBYSxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUMsYUFBYSxDQUFDLENBQUEifQ==